import { useState } from 'react';

import { useCart } from '../../../../hooks/useCart';

import './cart-item.scss';

import { Currency } from '../../../../utils/currency/Currency';
import { MenuItemOptionsModal } from '../../../modal/menu-item-options/MenuItemOptionsModal';
import { QuantitySelector } from '../../../quantity-selector/QuantitySelector';
import { ExpandableText } from '../../../see-more/ExpandableText';

export const CartItem = ({ item, onRemove }) => {
  const { incrementItem, decrementItem, updateCartItemOptions } = useCart();
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  const hasOptions = item.optionGroups?.length > 0;

  return (
    <div className="cart-item">
      <img src={item.imageUrl} alt={`Cart Item ${item.id}`} />
      <div>
        <div>
          <span className="cart__name">{item.name}</span>
          <Currency className="cart-item__price" value={item.price} />
        </div>
        <div>
          <span className="cart-item__description">
            <ExpandableText text={item.description} maxChars={100} canExpand={false} />
          </span>
        </div>
        {hasOptions && (
          <div className="cart-item__options">
            <span className="cart-item__options-text">{item.selectedOptions?.join(' | ')}</span>
            <button
              type="button"
              className="cart-item__edit-options"
              onClick={() => setShowOptionsModal(true)}
            >
              Edit
            </button>
          </div>
        )}
        <div className="cart-item__actions">
          <QuantitySelector
            quantity={item.quantity}
            onIncrement={() => incrementItem(item)}
            onDecrement={() => decrementItem(item)}
          />
        </div>
      </div>
      {hasOptions && (
        <MenuItemOptionsModal
          open={showOptionsModal}
          onOpen={setShowOptionsModal}
          item={item}
          initialSelectedOptionIds={item.selectedOptionIds}
          onConfirm={({ selectedOptionIds, selectedOptions, priceDelta }) => {
            updateCartItemOptions(item.cartLineId, { selectedOptionIds, selectedOptions, priceDelta });
          }}
        />
      )}
    </div>
  );
};
